<template>
  <div class="row max_2">
    <div class="home_acco skeleton" v-for="(item, index) in accomodations">
      <a v-bind:href="`${currentUrl}/acco/${item.slug}`">
        <div class="room-thumb">
          <img v-bind:src="mipmap(item.spotlightimage, 400)" alt="" class="room-image" srcset="" />
          <div class="main">
            <div class="info">
              <h5>{{ item.name }}</h5>
              <span class="location">{{ item.city }}, {{ item.state }}</span>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies'
export default {
  data() {
    return {
      accomodations: [],
      currentUrl: "",
    };
  },

  methods: {
    mipmap(src, res) {

      if (src.includes('https://media.xmlcal.com')) {
        var imgblocks = src.split("/");
        var imgfile = imgblocks[imgblocks.length - 1];
        var thumbnailimgsmall =
          imgfile.split(".")[0] + "." + res + "." + imgfile.split(".")[1];
        imgblocks[imgblocks.length - 1] = thumbnailimgsmall;
        return imgblocks.join("/");
      } else {
        return src;
      }
    },
  },

  created() {
    console.log(VueCookies.get('recently_viewed_content'))
    this.currentUrl = window.location.origin;
  },
};
</script>
